import { useMutation } from 'react-apollo';
import gql from 'graphql-tag';
import { useDeviceInfo } from '../../../retail-config/device';
import { generateCorrelationId } from '../../../lib';
import * as LoggerPlus from '../../../lib/logger-plus';
import { ISlotId } from '../../../types';

export const useRewardsCardSessionMutation = () => {
  const { slotId } = useDeviceInfo();
  const { type: deviceType } = slotId;
  const [mutate] = useMutation(publishPeripheralEventMutation);

  if (deviceType !== 'KIOSK') return () => null;

  return updatedRewardsCardSession;

  async function updatedRewardsCardSession({ playerCardNumber }: { playerCardNumber?: string } = {}) {
    const event = createPeripheralEvent({ playerCardNumber, slotId });

    try {
      await mutate({ variables: { event }, context: { skipGlobalErrorHandling: true } });
    } catch (e) {
      LoggerPlus.getLogger('rewards-session').error(
        e,
        `Failed to ${playerCardNumber ? 'start' : 'end'} Rewards card session.`
      );
    }
  }
};

const createPeripheralEvent = ({ playerCardNumber, slotId }: { playerCardNumber?: string; slotId: ISlotId }) =>
  JSON.stringify({
    metadata: {
      request: {
        id: generateCorrelationId(),
        venueId: slotId.venueId,
        deviceType: slotId.type,
        slotNumber: slotId.slotNumber
      },
      message: {
        id: generateCorrelationId(),
        domain: 'rewards',
        schemaVersion: '1.0.0',
        type: playerCardNumber ? 'REWARDS_SESSION_STARTED' : 'REWARDS_SESSION_ENDED'
      }
    },
    payload: {
      timestamp: Date.now(),
      playerId: playerCardNumber
    }
  });

const publishPeripheralEventMutation = gql`
  mutation publishPeripheralEvent($event: String!) {
    publishPeripheralEvent(event: $event)
  }
`;

export const forTestsOnly = {
  publishPeripheralEventMutation
};
